/**
 * Shake detection tuning — the one place to adjust sensitivity and timing.
 * Values are the ones shipped so far (unchanged behaviour).
 *
 * speed = (|Δx| + |Δy| + |Δz|) / Δt × 1000 over accelerationIncludingGravity
 * (m/s²) sampled at most every sampleIntervalMs. A shake is detected when
 * `eventCountThreshold` samples above the device threshold fall inside
 * `detectionWindowMs`; afterwards detection stays locked for `cooldownMs` and
 * re-arms only once the phone was still (speed < threshold × quietSpeedFactor)
 * for `rearmQuietMs`.
 */
export const SHAKE_TUNING = Object.freeze({
  sampleIntervalMs: 120,
  detectionWindowMs: 1000,
  eventCountThreshold: 4,
  cooldownMs: 4500,
  postResultLockMs: 2500,
  rearmQuietMs: 800,
  quietSpeedFactor: 0.35,
  threshold: Object.freeze({ ios: 55, android: 65, other: 70 }),
  // Fallbacks when the devicemotion listener can't be used.
  shakeJsThreshold: Object.freeze({ ios: 75, other: 85 }),
  orientationThresholdDeg: 360,
  preShakeAnimationMs: 800,
});

export const getShakeThreshold = (deviceInfo, tuning = SHAKE_TUNING) => {
  if (deviceInfo.isIOS) return tuning.threshold.ios;
  if (deviceInfo.isAndroid) return tuning.threshold.android;
  return tuning.threshold.other;
};
